module.exports = ".columns {\r\n    height: 70vh;\r\n}\r\n"